import $ from 'jquery';

class Underline {
  constructor() {
    this.underline = $('h1').has('span');

    if (!this.underline.length) {
      return;
    }

    this.setDoubleLine();
  }

  setDoubleLine() {
    this.underline.each((i, el) => {
      const self = $(el);
      const isUnderline =
        self.find('span').css('text-decoration-line') === 'underline';

      if (isUnderline) {
        self.addClass('u-double-line');
        self.find('span').css('text-decoration-line', 'none');
      }
    });
  }
}

export default Underline;



// WEBPACK FOOTER //
// ./src/scripts/modules/underline.js